module.exports = __webpack_public_path__ + "static/img/tx.9920e10.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tx.jpg
// module id = zETf
// module chunks = 0